export default{
  clients:{
    title: '认可和奖励',
    description: 'Maesinfo坚持不懈地为客户追求卓越的结果。',
    clients:[
      require('../../assets/images/services/client (1).jpg'),
      require('../../assets/images/services/client (2).jpg'),
      require('../../assets/images/services/client (3).jpg'),
      require('../../assets/images/services/client (4).jpg'),
      require('../../assets/images/services/client (5).jpg'),
      require('../../assets/images/services/client (6).jpg'),
      require('../../assets/images/services/client (7).jpg'),
      require('../../assets/images/services/client (8).jpg'),
      require('../../assets/images/services/client (9).jpg'),
      require('../../assets/images/services/client (10).jpg'),
    ]
  }
}
